import BillingCategoryModel from "#src/models/BillingCategoryModel.ts";
import { ChargeModel } from "#src/models/ChargeModel.ts";
import { CreditModel } from "#src/models/CreditModel.ts";
import { EventModel } from "#src/models/EventModel.ts";
import GroupRegistrationModel from "#src/models/GroupRegistrationModel.ts";
import { InvoiceItemCouponModel } from "#src/models/InvoiceItemCouponModel.ts";
import { InvoiceItemCreditModel } from "#src/models/InvoiceItemCredit.ts";
import { InvoiceItemDiscountModel } from "#src/models/InvoiceItemDiscountModel.ts";
import InvoiceModel from "#src/models/InvoiceModel.ts";
import MembershipModel from "#src/models/MembershipModel.ts";
import PrivateSerieAttendanceModel from "#src/models/PrivateSerieAttendanceModel.ts";
import PrivateSerieModel from "#src/models/PrivateSerieModel.ts";
import { RecurringChargeModel } from "#src/models/RecurringChargeModel.ts";
import { RecurringCreditModel } from "#src/models/RecurringCreditModel.ts";
import { RefundModel } from "#src/models/RefundModel.ts";
import UserModel from "#src/models/UserModel.ts";
import {
  addon,
  ChargeAmount,
  Fee,
  Frequency,
  invoice,
  type filteredInvoices,
} from "#types/code-generator.ts";

export const isInvoiceItem = (invoiceItem) =>
  invoiceItem instanceof InvoiceItemModel;

export class InvoiceItemModel {
  addon?: addon["addon"];
  amount: number;
  balanceAccountId?: string;
  billingCategory?: BillingCategoryModel;
  captyn?: Frequency;
  charge?: ChargeModel;
  chargeAmount?: Partial<ChargeAmount>;
  coupons?: InvoiceItemCouponModel[];
  createdAt?: Date;
  credit?: CreditModel;
  credits?: InvoiceItemCreditModel[];
  description: string;
  discounts?: InvoiceItemDiscountModel[];
  events?: EventModel[];
  fee?: Fee;
  groupRegistration?: GroupRegistrationModel;
  id?: string;
  invoice?: InvoiceModel;
  meet?: invoice["invoice"]["invoiceItems"][0]["meet"];
  membership?: MembershipModel;
  note?: string;
  notRemoveable?: boolean;
  omit?: boolean;
  payments?: filteredInvoices["invoices"][0]["invoiceItems"][0]["payments"];
  privateSerie?: PrivateSerieModel;
  privateSerieAttendance?: PrivateSerieAttendanceModel;
  quantity?: number;
  recurringCharge?: RecurringChargeModel;
  recurringCredit?: RecurringCreditModel;
  refunds?: RefundModel[];
  status?: string;
  user?: UserModel;

  constructor(data: Partial<InvoiceItemModel>) {
    Object.assign(this, data);
  }
}
